import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import "./LoginPage.css";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({ type: null, message: "" });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setPopup({ type: null, message: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE}/auth/token/`,
        formData
      );
      const { access, refresh } = res.data;
      const payload = JSON.parse(atob(access.split(".")[1]));
      const role = payload.role;
      login(access, refresh, role);
      setPopup({ type: "success", message: "Login successful! Redirecting..." });
      setTimeout(() => {
        if (["admin", "superadmin", "sales"].includes(role)) {
          navigate("/admin/dashboard");
        } else {
          navigate("/");
        }
      }, 1100);
    } catch (err) {
      setPopup({ type: "error", message: "Invalid username or password." });
    } finally {
      setLoading(false);
    }
  };

  function Popup({ type, message, onClose }) {
    if (!type) return null;
    return (
      <div className={`popup ${type}`} role="alert" aria-live="polite">
        <span>{message}</span>
        <span
          aria-label="Close"
          title="Close"
          className="popup-close"
          onClick={onClose}
        >
          ×
        </span>
      </div>
    );
  }

  return (
    <div className="login-bg">
      <Popup
        type={popup.type}
        message={popup.message}
        onClose={() => setPopup({ type: null, message: "" })}
      />
      <div className="login-main-card">
        <div className="login-card-left">
          <h2>Login</h2>
          <form onSubmit={handleSubmit} autoComplete="on">
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <div className="input-icon-wrapper">
                <input
                  className="login-input"
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Enter your username"
                  value={formData.username}
                  onChange={handleChange}
                  autoComplete="username"
                  required
                  aria-label="Username"
                />
                <span className="icon"><i className="fa fa-user" /></span>
              </div>
            </div>
            <div className="input-group">
              <label htmlFor="password">Password</label>
              <div className="input-icon-wrapper">
                <input
                  className="login-input"
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                  required
                  aria-label="Password"
                />
                <span className="icon"><i className="fa fa-lock" /></span>
              </div>
            </div>
            <button
              className="login-btn"
              type="submit"
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
            <div className="login-link">
              Don&apos;t have an account ?{" "}
              <span className="signup-link" onClick={() => navigate("/register")}>
                Sign Up
              </span>
            </div>
          </form>
        </div>
        <div className="login-card-right">
          <h1>WELCOME<br />BACK!</h1>
          <p></p>
        </div>
      </div>
      {/* FontAwesome CDN (for use if you aren't already importing it globally) */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
    </div>
  );
}